export const DATE_FORMAT: string = "DD-MM-YYYY";

export enum ENV {
  DEV = "dev",
  PROD = "prod",
  LOCAL = "local",
}
export enum SUPPORTED_LANGUAGES {
  EN = "en",
  AR = "ar",
}

export enum LOCAL_STORAGE_KEYS {
  THEME = "theme",
  LANGUAGE = "current_language",
}

export const VERSION_BUCKET_URL = `https://juleb-latest.s3.me-south-1.amazonaws.com/${
  process.env.REACT_APP_ENV || "prod"
}/auth_client.yml`;

export const AUTH_API = {
  LOGIN: "/auth_graphql/login",
  LOGOUT: "/auth_graphql/logout",
  FORGOT_PASSWORD: "/auth_graphql/forgot-password",
  RESET_PASSWORD: "/auth_graphql/reset-password",
};

/**
 * Password policy. This mirrors auth-graphql's src/common/password.ts, which in
 * turn mirrors Odoo's PASSWORD_PATTERN in juleb_brand/models/res_users.py.
 * All three must stay in sync: a rule that is looser here lets the user submit a
 * password the server rejects after the reset link has already been consumed.
 */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

/**
 * The individual requirements, used for both validation and the strength meter.
 * `key` is the suffix of the locale key under auth.resetPassword.rule.*.
 */
export const PASSWORD_RULES: { key: string; test: RegExp }[] = [
  { key: "length", test: new RegExp(`.{${PASSWORD_MIN_LENGTH},}`) },
  { key: "lowercase", test: /[a-z]/ },
  { key: "uppercase", test: /[A-Z]/ },
  { key: "digit", test: /\d/ },
  { key: "special", test: /[^A-Za-z0-9]/ },
];

export function passwordRulesMet(password: string): number {
  if (!password) {
    return 0;
  }
  return PASSWORD_RULES.filter((rule) => rule.test.test(password)).length;
}

export function isPasswordAcceptable(password: string): boolean {
  return (
    !!password &&
    password.length <= PASSWORD_MAX_LENGTH &&
    passwordRulesMet(password) === PASSWORD_RULES.length
  );
}
